import clsx from 'clsx';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { isV2Page, useV2Frame } from './v2Frame';

/**
 * Root of a master/detail page that owns its scrolling. In the V2 frame it
 * fills `main`; in the legacy frame (rollback) it is a bordered card sized
 * to the viewport under the legacy header. In the V2 frame the title sits
 * on the canvas and the workspace is the card underneath.
 */
export const FillPage: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const v2 = useV2Frame();
  // Hotel pages always fill: they render in HotelShell, which has no legacy
  // frame to roll back to, so the bordered-card branch is never right there.
  const hotel = pathname === '/hotel' || pathname.startsWith('/hotel/');
  const fills = hotel || (v2 && isV2Page(pathname));
  return (
    <div
      className={clsx(
        'flex min-h-0 flex-col',
        fills
          ? 'flex-1 gap-5 p-4 md:p-6 xl:px-8'
          : 'av2 h-[calc(100dvh-8rem)] min-h-[520px] overflow-hidden rounded-v2-lg border border-v2-line bg-v2-surface',
      )}
    >
      {children}
    </div>
  );
};
